var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar-1/calendar-1_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 0.625V1.875H13.125V0.625H14.375V1.875H17.5C18.5352 1.875 19.375 2.71482 19.375 3.75V17.5C19.375 18.5352 18.5352 19.375 17.5 19.375H2.5C1.46482 19.375 0.625 18.5352 0.625 17.5V3.75C0.625 2.71482 1.46482 1.875 2.5 1.875H5.625V0.625H6.875ZM6.875 3.125H13.125V4.375H14.375V3.125H17.5C17.8448 3.125 18.125 3.40518 18.125 3.75V5.625H1.875V3.75C1.875 3.40518 2.15518 3.125 2.5 3.125H5.625V4.375H6.875V3.125ZM1.875 6.875V17.5C1.875 17.8448 2.15518 18.125 2.5 18.125H17.5C17.8448 18.125 18.125 17.8448 18.125 17.5V6.875H1.875ZM5.625 9.375H4.375V10.625H5.625V9.375ZM9.375 9.375H10.625V10.625H9.375V9.375ZM5.625 13.125H4.375V14.375H5.625V13.125ZM9.375 13.125H10.625V14.375H9.375V13.125ZM15.625 9.375H14.375V10.625H15.625V9.375Z",
    fill: "#BDC2C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.027fc76c934824a8f68bfc3d0b9e2375.svg";
export { ForwardRef as ReactComponent };